export const PERFIL_MULTI_SEL = { S: "S", N: "N" }
export const PERFIL_CASE = { SIN_PERFIL: 1, ACTUALIZADO: 2, POR_VENCER: 3 };

export interface IPerfilListPerfiles {
  id: string;
  idperfil: string;
  nombre: string;
  codigo: string;
  fechacreacion: Date;
  fechamodificacion: Date;
  rangoCalculodesde: number;
  rangoCalculohasta: number;
  idpais: string;
  explicacion: string;
}

export interface IPerfilInversion {
  id: string;
  idpais: string;
  idcliente: string;
  idcanal: string;
  generadorpor: string;
  nombreasesor: any;
  emailasesor: any;
  fechacreacion: Date;
  fechamodificacion: Date;
  porvencer: boolean;
  idperfil_calculado: string;
  idperfil_aceptado: string;
  canal: IPerfilCanal;
  historicocalculoperfilcalculo: IPerfilHistorico;
}

export interface IPerfilNoPerfilResponse {
  status: number;
  code: string;
  message: string[];
}

export type IPerfilamientoCache = IPerfilInversion | IPerfilNoPerfilResponse;

export interface IPerfilInversionUi {
  perfilName: string;
  dateLast: Date;
  descripCard: string;
  validateCase: number;
  showPerfilname: boolean;
  showCard: boolean;
}

export interface IPerfilCanal {
  id: string;
  idcanal: string;
  descripcion: string;
  prioridad: number;
  fechacreacion: string;
  fechamodificacion: string;
}

export interface IPerfilHistorico {
  id: string;
  idpais: string;
  idformulario: string;
  idcliente: string;
  edad: number;
  idperfil: string;
  fechacreacion: Date;
  fechamodificacion: Date;
}

export interface IPerfilCuestionario {
  id: string;
  idformulario: string;
  idtipopregunta: number;
  descripcion: string;
  pregunta: string;
  orden: number;
  fechacreacion: string;
  fechamodificacion: string;
  explicacion: string;
  multiseleccion: string;
  tiporespuestapregunta: IPerfilCuestionarioPregunta[];
}

export interface IPerfilCuestionarioPregunta {
  id: string;
  idformulario: string;
  idtipopregunta: number;
  idtiporespuestapregunta: string;
  descripcion: string;
  orden: number;
  factorpuntaje: number;
  fechacreacion: string;
  fechamodificacion: string;
}

export interface IPerfilCalculadoOut {
  idpais: string;
  idcliente: string;
  edad: number;
  repuestas: IPerfilCuestionarioAnswersOut[];
}

export interface IPerfilCuestionarioAnswersOut {
  idtipopregunta: number;
  idtiporespuestapregunta: string;
}

export interface IPerfilCalculadoIn {
  id: string;
  idperfil: string;
  nombre: string;
  codigo: string;
  fechacreacion: Date;
  fechamodificacion: Date;
  rangoCalculodesde: number;
  rangoCalculohasta: number;
  idpais: string;
  explicacion: string;
  pordefecto: string;
}

export interface IPerfilGrabarOut {
  idcalculo: string;
  idpais: string;
  idcliente: string;
  nombre: string;
  apellido: string;
  idcanal: string;
  idperfil_calculado: string;
  idperfil_aceptado: string;
  generadorpor: string;
}

export interface IPerfilGrabarIn extends IPerfilGrabarOut {
  id: string;
  fechacreacion: Date;
  fechamodificacion: Date;
}